/** App screen mockup — renders a fake browser chrome around content. Import, never remake. */

import type { ReactNode } from "react";

interface ScreenMockProps {
  children: ReactNode;
  url?: string;
  dark?: boolean;
}

export function ScreenMock({ children, url = "raley.koda-software.com", dark = true }: ScreenMockProps) {
  const bg = dark ? "#0a0a0b" : "#fff";
  const chrome = dark ? "#1a1a1e" : "#f0f0f0";
  const border = dark ? "#2a2a32" : "#d0d0d0";
  const text = dark ? "#71717a" : "#666";

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        background: bg,
        border: `1px solid ${border}`,
        overflow: "hidden",
      }}
    >
      {/* Browser chrome */}
      <div
        style={{
          height: 36,
          background: chrome,
          borderBottom: `1px solid ${border}`,
          display: "flex",
          alignItems: "center",
          padding: "0 12px",
          gap: 8,
          flexShrink: 0,
        }}
      >
        <div style={{ display: "flex", gap: 6 }}>
          <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#ef4444" }} />
          <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#eab308" }} />
          <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#22c55e" }} />
        </div>
        <div
          style={{
            flex: 1,
            background: bg,
            border: `1px solid ${border}`,
            borderRadius: 4,
            padding: "2px 10px",
            fontSize: 11,
            color: text,
            fontFamily: "'JetBrains Mono', monospace",
          }}
        >
          {url}
        </div>
      </div>
      {/* Content */}
      <div style={{ flex: 1, overflow: "hidden", position: "relative" }}>{children}</div>
    </div>
  );
}
